import axios from 'axios';

let interceptorConfigured = false;

export function getJwtFromSearch(search = "") {
  try {
    return new URLSearchParams(search).get('jwt') || "";
  } catch (error) {
    return "";
  }
}

export function resolveJwt(search = "") {
  return getJwtFromSearch(search);
}

export function setupAxiosAuth() {
  if (interceptorConfigured) {
    return;
  }

  axios.defaults.withCredentials = true;

  axios.interceptors.request.use((config) => {
    const nextConfig = { ...config };
    const jwt = resolveJwt(window.location.search);

    nextConfig.withCredentials = nextConfig.withCredentials ?? true;

    if (jwt) {
      const headers = { ...(nextConfig.headers || {}) };
      const currentAuthHeader = headers.Authorization || headers.authorization;

      if (!currentAuthHeader || String(currentAuthHeader).trim() === '' || String(currentAuthHeader).trim() === 'Bearer') {
        headers.Authorization = `Bearer ${jwt}`;
      }

      nextConfig.headers = headers;
    }

    return nextConfig;
  });

  interceptorConfigured = true;
}
